import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import toast, { Toaster } from 'react-hot-toast';

var COLLATERAL_PRESETS = ['Nothing', 'Cheque', 'Vehicle', 'Laptop', 'Gold/Jewelry', 'Property Papers', 'Other'];

export default function CustomerForm() {
  var params = useParams();
  var id = params.id;
  var navigate = useNavigate();
  var isEdit = Boolean(id);

  var _name = useState(''), name = _name[0], setName = _name[1];
  var _addr = useState(''), address = _addr[0], setAddress = _addr[1];
  var _ph1 = useState(''), phone1 = _ph1[0], setPhone1 = _ph1[1];
  var _area = useState(''), area = _area[0], setArea = _area[1];
  var _ph2 = useState(''), phone2 = _ph2[0], setPhone2 = _ph2[1];
  var _aad = useState(''), aadhar = _aad[0], setAadhar = _aad[1];
  var _reference = useState(''), reference = _reference[0], setReference = _reference[1];
  // Fixes a real bug: these three fields already existed in state and were
  // submitted to the server, but the form never actually rendered inputs
  // for them, so they were always blank/default no matter what.
  var _collateralType = useState('Nothing'), collateralType = _collateralType[0], setCollateralType = _collateralType[1];
  var _collateralCustom = useState(''), collateralCustom = _collateralCustom[0], setCollateralCustom = _collateralCustom[1];
  var _collateralDetails = useState(''), collateralDetails = _collateralDetails[0], setCollateralDetails = _collateralDetails[1];
  var _agentName = useState(''), agentName = _agentName[0], setAgentName = _agentName[1];
  var _pan = useState(''), pan = _pan[0], setPan = _pan[1];
  var _photo = useState(null), photo = _photo[0], setPhoto = _photo[1];
  var _preview = useState(null), photoPreview = _preview[0], setPhotoPreview = _preview[1];
  var _load = useState(false), loading = _load[0], setLoading = _load[1];

  // Reference: type-ahead against existing customers, or just type a custom
  // name if the person isn't an existing client.
  var _allCustomers = useState([]), allCustomers = _allCustomers[0], setAllCustomers = _allCustomers[1];
  var _showRefSuggestions = useState(false), showRefSuggestions = _showRefSuggestions[0], setShowRefSuggestions = _showRefSuggestions[1];

  useEffect(function() {
    api.get('/customers').then(function(r) { setAllCustomers(r.data); }).catch(function() {});
  }, []);

  useEffect(function() {
    if (isEdit) {
      api.get('/customers/' + id).then(function(r) {
        var c = r.data;
        setName(c.name); setAddress(c.address); setPhone1(c.phone1);
        setArea(c.area || ''); setPhone2(c.phone2 || ''); setAadhar(c.aadhar || ''); setPan(c.pan || '');
        setReference(c.reference_name || '');
        setAgentName(c.agent_name || '');
        setCollateralDetails(c.collateral_details || '');
        var savedType = c.collateral_type || 'Nothing';
        if (COLLATERAL_PRESETS.indexOf(savedType) !== -1) {
          setCollateralType(savedType);
        } else {
          // A custom collateral type saved previously that isn't one of
          // the presets - show it via the "Other" + custom text path.
          setCollateralType('Other');
          setCollateralCustom(savedType);
        }
        if (c.photo_url) setPhotoPreview(window.UPLOAD_BASE + c.photo_url);
      }).catch(function() { toast.error('Failed to load customer'); });
    }
  }, [id]);

  function handlePhotoChange(e) {
    var file = e.target.files[0];
    if (file) {
      setPhoto(file);
      var reader = new FileReader();
      reader.onload = function(ev) { setPhotoPreview(ev.target.result); };
      reader.readAsDataURL(file);
    }
  };

  var refQuery = reference.trim().toLowerCase();
  var refMatches = refQuery === '' ? [] : allCustomers.filter(function(c) {
    return c.id !== parseInt(id) && c.name && c.name.toLowerCase().indexOf(refQuery) !== -1;
  }).slice(0, 8);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name || !address || !phone1) { toast.error('Name, address and phone are required'); return; }
    setLoading(true);
    try {
      var formData = new FormData();
      formData.append('name', name);
      formData.append('address', address);
      formData.append('area', area);
      formData.append('phone1', phone1);
      formData.append('phone2', phone2);
      formData.append('aadhar', aadhar);
      formData.append('pan', pan);
      formData.append('reference_name', reference);
      formData.append('agent_name', agentName);
      formData.append('collateral_type', collateralType === 'Other' ? (collateralCustom.trim() || 'Other') : collateralType);
      formData.append('collateral_details', collateralDetails);
      if (photo) formData.append('photo', photo);

      if (isEdit) {
        await api.put('/customers/' + id, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success('Customer updated!');
      } else {
        var res = await api.post('/customers', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success('Customer #' + res.data.client_number + ' created!');
      }
      setTimeout(function() { navigate('/customers'); }, 1500);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  return React.createElement('div', { style: { maxWidth: 600, margin: '0 auto' } },
    React.createElement(Toaster, { position: 'top-right' }),
    React.createElement('h2', { style: { fontSize: 24, fontWeight: 'bold', marginBottom: 24 } }, isEdit ? 'Edit Customer' : 'Add New Customer'),
    React.createElement('form', { onSubmit: handleSubmit, style: { background: 'white', borderRadius: 12, padding: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' } },

      React.createElement('div', { style: { marginBottom: 20, textAlign: 'center' } },
        React.createElement('div', { style: { width: 100, height: 100, borderRadius: '50%', background: '#f3f4f6', margin: '0 auto 10px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px dashed #d1d5db' } },
          photoPreview
            ? React.createElement('img', { src: photoPreview, alt: '', style: { width: '100%', height: '100%', objectFit: 'cover' } })
            : React.createElement('span', { style: { fontSize: 40 } }, '\u{1F464}')
        ),
        React.createElement('label', { style: { display: 'inline-block', background: '#2563eb', color: 'white', padding: '6px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 13 } },
          photoPreview ? 'Change Photo' : 'Upload Photo',
          React.createElement('input', { type: 'file', accept: 'image/*', onChange: handlePhotoChange, style: { display: 'none' } })
        )
      ),

      React.createElement('div', { style: { marginBottom: 16 } },
        React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Name *'),
        React.createElement('input', { type: 'text', value: name, onChange: function(e) { setName(e.target.value); }, required: true, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
      ),
      React.createElement('div', { style: { marginBottom: 16 } },
        React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Address *'),
        React.createElement('textarea', { value: address, onChange: function(e) { setAddress(e.target.value); }, required: true, rows: 2, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
      ),
      React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 } },
        React.createElement('div', null,
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Phone Number *'),
          React.createElement('input', { type: 'tel', value: phone1, onChange: function(e) { setPhone1(e.target.value); }, required: true, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
        ),
        React.createElement('div', null,
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Area'),
          React.createElement('input', { type: 'text', value: area, onChange: function(e) { setArea(e.target.value); }, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
        )
      ),
      React.createElement('div', { style: { marginBottom: 16 } },
        React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Phone 2 (Optional)'),
        React.createElement('input', { type: 'tel', value: phone2, onChange: function(e) { setPhone2(e.target.value); }, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
      ),
      React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 } },
        React.createElement('div', null,
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Aadhar'),
          React.createElement('input', { type: 'text', value: aadhar, onChange: function(e) { setAadhar(e.target.value); }, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
        ),
        React.createElement('div', null,
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'PAN'),
          React.createElement('input', { type: 'text', value: pan, onChange: function(e) { setPan(e.target.value); }, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
        )
      ),

      // Reference: type-ahead against existing customers, or type a name
      // freely if they aren't an existing client — as requested.
      React.createElement('div', { style: { marginBottom: 16, position: 'relative' } },
        React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Reference'),
        React.createElement('input', {
          type: 'text', value: reference,
          onChange: function(e) { setReference(e.target.value); setShowRefSuggestions(true); },
          onFocus: function() { setShowRefSuggestions(true); },
          onBlur: function() { setTimeout(function() { setShowRefSuggestions(false); }, 150); },
          placeholder: 'Type a name — pick a client below, or just type a custom name',
          style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' }
        }),
        showRefSuggestions && refMatches.length > 0 && React.createElement('div', {
          style: { position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20, background: 'white', border: '1px solid #d1d5db', borderRadius: 8, marginTop: 4, maxHeight: 220, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
        },
          refMatches.map(function(c) {
            return React.createElement('div', {
              key: c.id,
              onMouseDown: function(ev) { ev.preventDefault(); setReference(c.name); setShowRefSuggestions(false); },
              style: { padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13 }
            }, c.name + ' (#' + c.client_number + ')');
          })
        )
      ),

      // Collateral: common presets, or "Other" with a custom type, plus
      // free-text details either way — as requested.
      React.createElement('div', { style: { display: 'grid', gridTemplateColumns: collateralType === 'Other' ? '1fr 1fr' : '1fr', gap: 12, marginBottom: 16 } },
        React.createElement('div', null,
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Collateral'),
          React.createElement('select', { value: collateralType, onChange: function(e) { setCollateralType(e.target.value); }, style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } },
            COLLATERAL_PRESETS.map(function(p) { return React.createElement('option', { key: p, value: p }, p); })
          )
        ),
        collateralType === 'Other' && React.createElement('div', null,
          React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Specify'),
          React.createElement('input', { type: 'text', value: collateralCustom, onChange: function(e) { setCollateralCustom(e.target.value); }, placeholder: 'e.g. Scooter, Tools, TV...', style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
        )
      ),
      collateralType !== 'Nothing' && React.createElement('div', { style: { marginBottom: 16 } },
        React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Collateral Details (Optional)'),
        React.createElement('input', { type: 'text', value: collateralDetails, onChange: function(e) { setCollateralDetails(e.target.value); }, placeholder: 'e.g. Cheque #1234, Activa - GJ01AB1234', style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
      ),

      // Agent: just a tag for "who brought us this client" — no other
      // effects, shown alongside the customer and in Collections.
      React.createElement('div', { style: { marginBottom: 20 } },
        React.createElement('label', { style: { display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 4 } }, 'Agent (Optional)'),
        React.createElement('input', { type: 'text', value: agentName, onChange: function(e) { setAgentName(e.target.value); }, placeholder: 'Name of the person who brought this client, if any', style: { width: '100%', padding: 10, border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' } })
      ),

      React.createElement('div', { style: { display: 'flex', gap: 12 } },
        React.createElement('button', { type: 'submit', disabled: loading, style: { flex: 1, padding: 12, background: loading ? '#9ca3af' : '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontWeight: 500, cursor: loading ? 'default' : 'pointer' } },
          loading ? 'Saving...' : (isEdit ? 'Update Customer' : 'Save Customer')
        ),
        React.createElement('button', { type: 'button', onClick: function() { navigate('/customers'); }, style: { flex: 1, padding: 12, background: '#d1d5db', border: 'none', borderRadius: 8, fontWeight: 500, cursor: 'pointer' } }, 'Cancel')
      )
    )
  );
}
